module.exports = __webpack_public_path__ + "img/s2.e51d41bc.png";